<script>

import CommonService from '../../services/common';
import AutoComplete from 'primevue/autocomplete';


export default {
    components: { AutoComplete },
    props: [ 'modelValue',
        'field', 'staticOptions','value', 'disabled', 'api', 'format', 'sortField', 'updateModel', 'updateField', 'onItemSelect', 'queryField', 'selectFirst', 'selectLast', 'refreshValueOnLoad'],
    emits: ['update:modelValue'],
    data(){
        return {
            v: null,
            selectedItem: null,
            options: [],
            filteredOptions: [],
        }
    },
    mounted(){
        this.loadOptions();
    },
    watch: {
        api() {
            this.loadOptions();
        },
        queryField() {
            this.loadOptions();
        },
        v: function(){
        },
        modelValue(){
            this.refreshValue();
        },
        staticOptions(){
            this.loadOptions();
        }
    },
    methods: {
        refreshValue(){
            if(this.options && this.options.length > 0){
                let res = this.options.filter((item) => {
                    return item[this.format.value] == this.modelValue;
                });

                if(this.v == null || this.modelValue != this.v[this.format.value]){
                    this.v = res.length > 0 ? res[0] : null;
                    if(this.onItemSelect){
                        this.onItemSelect({value: this.v}, this.field)
                    }
                }
            }
        },
        loadOptions(api = null){
            if(this.api || api){
                let params = {};
                if(this.sortField){
                    params = {
                        sort: JSON.stringify([{property: this.sortField, direction: 'asc'}])
                    };
                }
                if(this.queryField){
                    params = { ...params, ...this.queryField };
                }
                

                CommonService.loadGeneric(api ?? this.api, params, response => {
                    if(response.success){
                        this.options = [];
                        this.options.push(...response.data);

                        // this.filteredOptions = [];
                        // this.filteredOptions.push(...response.data);

                        if(this.modelValue){
                            this.refreshValue();
                        } else {
                            if (this.selectFirst) {
                                this.v = this.options[0];
                                this.$emit('update:modelValue', this.v[this.format.value]);
                            }else if(this.selectLast){
                                this.v = this.options[this.options.length - 1];
                                this.$emit('update:modelValue', this.v[this.format.value]);
                            }
                        }
                    }
                });
            }else{
                this.options = this.staticOptions;
                if(this.refreshValueOnLoad){
                    this.refreshValue();
                }
                // this.filteredOptions = this.staticOptions;
            }

        },
        changeStaticOptions(list){
            this.options = [...list];
            // this.filteredOptions = [...list];
            if (this.options && this.options.length > 0 && (this.selectFirst || this.selectLast)) {
                this.v = this.selectFirst ? this.options[0] : this.options[this.options.length - 1];
                this.$emit('update:modelValue', this.v[this.format.value]);
                if(this.onItemSelect){
                    this.onItemSelect({value: this.v}, this.field)
                }
            }else{
                this.v = null;
            }
        },
        addStaticOption(el, select){
            this.options.push(el);
            // this.filteredOptions.push(el);
            if(select){
                this.v = this.options[this.options.length-1];
                this.$emit('update:modelValue', this.v[this.format.value]);
            }
        },
        filter(event){
            if(this.options){
                if (!event.query.trim().length) {
                    this.filteredOptions = [...this.options];
                }
                else {
                    this.filteredOptions = this.options.filter((item) => {
                        if(typeof this.format.label === 'function'){
                            return this.format.label(item).toLowerCase().includes(event.query.toLowerCase())
                        }
                        return item[this.format.label].toLowerCase().includes(event.query.toLowerCase());
                    });
                }
            }else{
                this.filteredOptions= [];
            }
        },
        updateModelValue(event){
            this.$emit('update:modelValue', event ? event[this.format.value] : null);
        },
        getOptions(){
            return this.options;
        },
        callOnItemSelect(){
            if(this.onItemSelect){
                this.onItemSelect({value: this.v}, this.field)
            }
        },
        getCompleteValue(){
            return this.v;
        },
        onItemSelectInternal(){
            if(this.onItemSelect){
                this.onItemSelect({value: this.v}, this.field)
            }
        }
    }
}

/**
:field="field"
v-model="data[field.name]" 
:disabled="disabled || field.readOnly || (field.disabledInEdit && id != 0)" 
:api="field.selectApi"
:sortField="field.sortField ?? null"
v-if="field.type == 'select'" 
:format="field.selectFormat"
**/
</script>


<template>
    <AutoComplete ref="autoc" 
        v-model="v"
        @update:modelValue="updateModelValue"
        :field="format.label" :suggestions="filteredOptions" 
        dropdown forceSelection 
        @complete="filter($event)"
        @item-select="onItemSelectInternal"
        :disabled="disabled" />
</template>

